<template>
    <b-container class='page-container'>
        <b-row>
            <b-col sm='12'>
                <b-card title='Leaderboard'>
                    <b-row>
                        <b-col />
                        <b-col>
                            <b-button-group size="sm">
                                <b-button :pressed="!isCareer" @click="toggleBoard(false)"
                                    variant="primary">Season</b-button>
                                <b-button :pressed="isCareer" @click="toggleBoard(true)"
                                    variant="primary">Career</b-button>
                            </b-button-group>
                        </b-col>
                        <b-col />
                    </b-row>
                    <b-table :fields="fields" :items='players' :busy='isBusy' :sort-by.sync="sortBy"
                        empty-text='Please check back later for results' show-empty responsive>
                        <template #empty="scope">
                            <h5>{{ scope.emptyText }}</h5>
                        </template>

                        <template #table-busy>
                            <div class="text-center text-info my-2">
                                <b-spinner class="align-middle" variant='info'></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'Leaderboard',
        data() {
            return {
                isBusy: false,
                isCareer: false,
                sortBy: 'ranking',
                fields: [{
                    key: 'ranking',
                    label: 'Ranking'
                }, {
                    key: 'player',
                    label: 'Player'
                }, {
                    key: 'seasonEarnings',
                    label: 'Earnings'
                }],
                players: []
            };
        },
        methods: {
            toggleBoard(isCareer) {
                if (this.isCareer != isCareer) {
                    this.isCareer = isCareer;
                    if (this.isCareer) {
                        this.fields = [{
                            key: 'careerRanking',
                            label: 'Ranking'
                        }, {
                            key: 'player',
                            label: 'Player'
                        }, {
                            key: 'careerEarnings',
                            label: 'Earnings'
                        }];
                        this.sortBy = 'careerRanking';
                    } else {
                        this.fields = [{
                            key: 'ranking',
                            label: 'Ranking'
                        }, {
                            key: 'player',
                            label: 'Player'
                        }, {
                            key: 'seasonEarnings',
                            label: 'Earnings'
                        }];
                        this.sortBy = 'ranking';
                    }
                }
            }
        },
        created() {
            this.isBusy = true;
            this.$axios.get('/api/leaderboard').then(results => {
                this.players = results.data;
            }).finally(() => {
                this.isBusy = false;
            });
        }
    }

</script>

<style lang='scss'>

</style>
